import Modal from "@stadium/ui/src/components/ModalNew";
import Portal from "@stadium/ui/src/components/portal";

import { ModalContent, ModalDialog } from "@stadium/ui/src/components/ModalNew/utils";

import AddressConfirmation from "@stadium/checkout/src/components/shipping-address/address-confirmation";

import styles from "../address.module.scss";

const AddressConfirmationModal = ({ ...props }) => (
  <Portal id="modal-root" dataContainerId="address-confirmation-modal">
    <Modal closeModal={props.closeModal} className={styles.editModal} mobileBottomDrawer>
      <ModalDialog className={styles.modalDialog}>
        <ModalContent className={`${styles.primaryModalContent} ${styles.addressModalContent}`}>
          <AddressConfirmation {...props} />
        </ModalContent>
      </ModalDialog>
    </Modal>
  </Portal>
);

export default AddressConfirmationModal;
